import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApplicationService } from '../../core/services/application.service';
import { RouteChannelMessage } from '../../core/interfaces/interfaces';
import { CustomerCartComponent } from './customer-cart/customer-cart.component';
import { BannerComponent } from './banner/banner.component';
import { BranchBanner, Order } from '../../graphql/generated';
import { DatabaseService } from '../../core/services/database.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'pegasus-customer-cart-or-banner',
  standalone: true,
  imports: [BannerComponent, CustomerCartComponent],
  templateUrl: './customer-cart-or-banner.component.html',
  styleUrl: './customer-cart-or-banner.component.scss',
})
export class CustomerCartOrBannerComponent implements OnInit, OnDestroy {
  showCart = false;
  fullScreenBanners: string[] = [];
  halfScreenBanners: string[] = [];
  cart: Order | null = null;
  private routeBroadcastChannel: BroadcastChannel;
  private cartBroadcastChannel: BroadcastChannel;
  private routerSubscription: Subscription;

  constructor(
    private applicationService: ApplicationService,
    private databaseService: DatabaseService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.routeBroadcastChannel = new BroadcastChannel('route');
    this.cartBroadcastChannel = new BroadcastChannel('cart');
  }

  ngOnInit(): void {
    this.routeBroadcastChannel.onmessage = (event) => {
      this.handleRouteChannelMessage(event);
    };

    this.cartBroadcastChannel.onmessage = (event) => {
      this.handleCartChannelMessage(event);
    };

    this.setBanners();
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }

    this.routeBroadcastChannel.close();
    this.cartBroadcastChannel.close();
  }

  private async setBanners() {
    const branchId = this.activatedRoute.snapshot.paramMap.get('branchId')!;
    const branchBranners = await this.databaseService.getBranchBanners(branchId);
    this.fullScreenBanners = this.filterBannersByType(branchBranners, 'FULL_SCREEN');
    this.halfScreenBanners = this.filterBannersByType(branchBranners, 'HALF_SCREEN');
  }

  private handleRouteChannelMessage(event: MessageEvent) {
    const message: RouteChannelMessage = event.data;
    const currentTabId = this.applicationService.getTabId();

    if (message.tabId !== currentTabId) {
      const url = message.url;
      this.showCart = url.includes('billing');
    }
  }

  private handleCartChannelMessage(event: MessageEvent) {
    const message = event.data;
    const currentTabId = this.applicationService.getTabId();

    if (message.tabId !== currentTabId) {
      const cart = message.cart;
      const items = cart?.items || [];
      this.cart = items.length > 0 ? cart : null;
      this.showCart = items.length > 0;
    }
  }

  private filterBannersByType(branchBanners: BranchBanner[], type: string) {
    return branchBanners
      .filter((branchBanner) => branchBanner.branch_banner_type === type)
      .map((branchBanner) => branchBanner.image_url);
  }
}
